<template>
  <v-menu v-model="open" class="filter-menu" left offset-x :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-badge color="marca-1" :value="filtersQuantity" :content="filtersQuantity" overlap>
        <mf-button color="cinza-0" icon="filter_list" type="icon" v-on:click.native="on.click" />
      </v-badge>
    </template>

    <v-card width="285px">
      <v-card-text>
        <p class="title">Filtros</p>
        <v-container class="px-0 py-0">
          <v-row>
            <v-col cols="12">
              <v-row no-gutters class="d-flex align-center">
                <label class="detail-title">Quantidade mínima de dias de compra</label>
                <v-tooltip bottom max-width="300px">
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      <mf-icon small color="cinza-0">info</mf-icon>
                    </span>
                  </template>
                  <span>
                    Esse filtro indica a quantidade mínima de dias que o consumidor deve ter comprado um produto para que ele seja considerado na análise que
                    gera a nossa predição. Ou seja, quanto mais alto esse número mais precisa será a análise, e também menor a quantidade de consumidores sendo
                    considerados.
                  </span>
                </v-tooltip>
              </v-row>
              <mf-number-input v-model="filters.minQntPurchaseDays" auto-format hide-details outlined show-arrows :min="0" @blur="$emit('update-data', true)" />
            </v-col>
            <v-col cols="12">
              <label class="detail-title">Período</label>
              <data-ahead-select v-model="filters.date" hide-details default-date="proximosSeteDias" @input="$emit('update-data', true)" />
            </v-col>
            <v-col cols="12">
              <label class="detail-title">Lojas</label>
              <mf-select-units-dialog
                solo
                hide-details
                check-all-units-on-init
                :selected-units.sync="filters.units"
                :selected-units-configuration.sync="filters.unitsConfiguration"
                :units="units"
                :tag-list="tagList"
                :group-list="unitsGroups"
                hide-ecommerce-configuration
                enable-inactive-units-selection
              />
            </v-col>
            <v-col cols="12">
              <label class="detail-title">Produtos</label>
              <modal-graphql-search-content hide-details :selected-items.sync="filters.products" item-type="produto" @input="$emit('update-data', true)" />
            </v-col>
            <v-col cols="12">
              <label class="detail-title">Segmentos</label>
              <segmentos-dialog
                v-model="filters.selectedSegments"
                :required="false"
                solo
                single-line
                outlined
                :selecionados.sync="filters.selectedSegments"
                template-type="input"
                @change="$emit('update-data', true)"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <mf-action-buttons
        class="pb-2 mx-4"
        :primary-button="{
          text: 'Fechar',
          action: () => (open = false),
          isVisible: true,
        }"
        :cancel-button="{
          text: 'Limpar',
          action: () => $emit('clear-filters'),
          isVisible: true,
        }"
      />
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'MariaFilters',
  components: {
    ModalGraphqlSearchContent: () => import('@/components/ModalGraphqlSearchContent.vue'),
    DataAheadSelect: () => import('@/components/DataAheadSelect.vue'),
    SegmentosDialog: () => import('@/modules/campanhas/views/components/SegmentosDialog.vue'),
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    filtersQuantity: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    open: false,
  }),
  computed: {
    ...mapGetters(['units', 'tagList', 'unitsGroups']),
  },
  watch: {
    'filters.units'() {
      this.$emit('update-data', true)
    },
  },
}
</script>
